import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';


import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-add-authority',
  templateUrl: './add-authority.component.html',
  styleUrls: ['./add-authority.component.scss'],
})
export class AddAuthorityComponent implements OnInit {
  authorityForm!: FormGroup;
  authorities: any[] = [];
  buttonColorName: any;
  allListingEmployee: any = []
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserEmpCode: any | null;
  loggedInUserId: any | null;
  loggedInUserName: any | null;
  loggedInUserRole: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInUserRoles: any;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoleIsEmployee: boolean = false;
  editAuthorityData:any;
mainComponentData:any;
  constructor(
    public sharedService: SharedService,
    private loader: LoaderService,
    private encryptionService: EncryptionService,
    private httpService: HttpService,
    private config: Config,
    public router: Router,
    private fb: FormBuilder,
    public dialog: MatDialog,
    private activatedroute: ActivatedRoute,
    public dialogRef: MatDialogRef<AddAuthorityComponent>,
    @Inject(MAT_DIALOG_DATA) public autoritydata: any, 
    private cdRef: ChangeDetectorRef
  ) {
  
    this.mainComponentData=autoritydata;
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.authorityForm = this.fb.group({
      employeeId: ['', Validators.required],
      isActive: [true],
      allocatingDep: ['', Validators.required],
      assetAuthorityId:[]
    });
console.log( this.mainComponentData);
this.editAuthorityData=this.mainComponentData.operation=='Add';
    this.mainComponentData.data !=null?this.editAuthorityData==true:this.editAuthorityData==false


    if( this.mainComponentData?.data!=null){
      this.authorityForm.patchValue({
        employeeId: this.mainComponentData.data.userId,
        isActive: true, // Assuming it's active by default
        allocatingDep: this.mainComponentData.data.assetDepartmentName,
        assetAuthorityId: this.mainComponentData.data.assetAuthorityId
      });
    }
  }
  ngOnInit() {



    this.buttonColorName = sessionStorage.getItem('buttonColorName');

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;


    if (this.loggedInUserRoles.length == 1) {
      for (let i = 0; i < this.loggedInUserRoles?.length; i++) {
        if (this.loggedInUserRoles[i].displayName == "Employee") {
          this.loggedInUserRoleIsEmployee = true
        }
      }
    }
    this.getAllAssetManagementApi();
  }

  hasError(controlName: any, errorType: any) {
    const control = this.authorityForm.get(controlName);
    return control?.hasError(errorType) && control.touched;
  }

  getAllAssetManagementApi() {
    this.getEmployee()
  }


  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      console.log(data);

      this.allListingEmployee = data.data;

    })
  }


  onSubmit() {
    let postData = this.authorityForm.value;
    const formData = {
      "assetDepartmentName": postData.allocatingDep,
      "userId": postData.employeeId,
      "companyId": this.loggedInUserCompanyID,
      "year": this.mainComponentData.year,
      "fiscalYear": this.mainComponentData.fiscal_year
    };
    
    console.log(this.authorityForm.value);
  
    this.httpService.callPostService(this.config.addAssetAuthority, formData).subscribe(
      (data: any) => {
        if (data) {
          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });
  
          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close();
          });
        }
      },
      (error: any) => {
        
        const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: error.error.error|| 'Duplicate entry not allowed',
            btn2: 'OK',
            btn2BgColor: 'red', // Highlight error with red button color
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: true
          }
        });
        
        errorDialogRef.afterClosed().subscribe(() => {
          // Optionally handle any action after closing the error dialog
          console.log('Error dialog closed');
        });
      }
    );
  }
  
 
updateAutority() {
    let updateData = this.authorityForm.value;
    const formData = {
      "assetDepartmentName": updateData.allocatingDep,
      "userId": updateData.employeeId,
      "companyId": this.loggedInUserCompanyID,
    
    };
    
    console.log(this.authorityForm.value);
  
    this.httpService.callPutService(`${this.config.updateAssetAuthority}/${updateData.assetAuthorityId}`, formData).subscribe(
      (data: any) => {
        console.log(data);
        
        if (data) {
          // Success popup
          const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
            disableClose: true,
            height: '25%',
            width: '30%',
            data: {
              msg: data.message,
              btn2: 'OK',
              btn2BgColor: this.buttonColorName,
              showSuccessIcon: true,
              showSuccessMessage: false,
              showCloseIcon: false
            }
          });
  
          // Handle the result of the dialog
          dialogRef.afterClosed().subscribe(() => {
            this.dialogRef.close();
          });
        }
      },
      (error: any) => {
        console.log(error);
        
        const errorDialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: error.error.error|| 'An error occurred while processing your request. Please try again.',
            btn2: 'OK',
            btn2BgColor: 'red', // Highlight error with red button color
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: true
          }
        });
        
        errorDialogRef.afterClosed().subscribe(() => {
          // Optionally handle any action after closing the error dialog
          console.log('Error dialog closed');
        });
      }
    );
  }
  
  cancelData() {
    this.dialogRef.close();
  }
}
